import { render, staticRenderFns } from "./PointSales.vue?vue&type=template&id=38f85903&"
import script from "./PointSales.vue?vue&type=script&lang=js&"
export * from "./PointSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports